import { withTransaction } from '@elastic/apm-rum-react'
import { Campaign, LogService, ReferralsService, UserInDetails } from '@hub/shared'
import { SqCardToCopy, SqLoader } from '@squidit/react-css'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ScheduleProps extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
  userInCampaign: UserInDetails
}

const ReferralsLinkComponent = ({ campaign, userInCampaign }: ScheduleProps) => {
  const [t] = useTranslation('campaignContentOrientation')
  const logService = useMemo(() => new LogService(), [])
  const referralsService = useMemo(() => new ReferralsService(), [])
  const [referrals, setReferrals] = useState([])
  const [loadingLink, setLoadingLink] = useState(false)

  const getShareLinks = useCallback(async () => {
    try {
      if (campaign?.activation?.hasTrackLink) {
        setLoadingLink(true)
        const response = await referralsService.getReferralsLink(userInCampaign?.idNetwork, campaign?._id)
        setReferrals(response)
        setLoadingLink(false)
      }
    } catch (error) {
      setLoadingLink(false)
      logService.error({ message: 'Failed to get shared links', error })
    }
  }, [logService, campaign, referralsService, userInCampaign])

  useEffect(() => {
    getShareLinks()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loadingLink) {
    return (
      <div className="display-flex justify-content-center">
        <SqLoader size="big" />
      </div>
    )
  }
  if (!referrals.length || !campaign?.activation?.hasTrackLink) {
    return null
  }
  return (
    <div>
      <hr />
      <h5>{t('linkShare')}</h5>
      {referrals?.map((link) => (
        <SqCardToCopy title={link?.title} content={link?.url} key={`${link.url}`} />
      ))}
    </div>
  )
}

export default withTransaction('ReferralsLinkComponent', 'component')(ReferralsLinkComponent)
